import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api/client";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = unknown/loading, false = guest
    const [loading, setLoading] = useState(true);

    const refreshMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(false);
            return null;
        }
    }, []);

    useEffect(() => {
        (async () => {
            await refreshMe();
            setLoading(false);
        })();
    }, [refreshMe]);

    const loginPin = async (email, pin) => {
        const { data } = await api.post("/auth/login/pin", { email, pin });
        setUser(data);
        return data;
    };
    const loginPassword = async (email, password) => {
        const { data } = await api.post("/auth/login/password", { email, password });
        setUser(data);
        return data;
    };
    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {
            // ignore — client-side logout still clears local state
        }
        setUser(false);
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, loginPin, loginPassword, logout, refreshMe }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    const v = useContext(AuthCtx);
    if (!v) throw new Error("useAuth outside provider");
    return v;
}
